import { h } from 'preact'
import dayjs from 'dayjs'

import cx from '../../shared/classes'
import * as style from './calendar.css'

interface Props {
    currentDate: Date
    setCurrentDate: (date: Date) => void
}

const CalendarMonthSelector: preact.FunctionalComponent<Props> = ({ currentDate, setCurrentDate }) => {
    const today = new Date()
    const isLeftArrowDisabled = dayjs(today).month() === dayjs(currentDate).month()

    const nextMonth = () => {
        setCurrentDate(dayjs(currentDate).add(1, 'month').toDate())
    }
    const prevMonth = () => {
        setCurrentDate(dayjs(currentDate).add(-1, 'month').toDate())
    }

    return (
        <div
            className={cx({
                [style.header]: true,
                [style.row]: true,
            })}
        >
            <div className={style.monthShift}>
                <div
                    className={cx({
                        [style.icon]: true,
                        [style.iconDisabled]: isLeftArrowDisabled,
                    })}
                    onClick={prevMonth}
                >
                    chevron_left
                </div>
                <span className={style.monthName}>{dayjs(currentDate).format('MMMM YYYY')}</span>
                <div className={style.icon} onClick={nextMonth}>
                    chevron_right
                </div>
            </div>
        </div>
    )
}

export default CalendarMonthSelector
